import type { IamApi } from '@/features/iam/api/iam-api'
import type { Id } from '@/infra/id'

export class MagicLinkStore {
  constructor(private readonly _api: IamApi) {}

  /**
   * Requests a magic link for the specified email address and workspace ID.
   */
  async request(workspaceId: Id, email: string): Promise<void> {
    return this._api.magicLinks.request(workspaceId, email)
  }
}
